
const messages = {
  alpha_dash: () => 'Поле может содержать только буквы, цифры и дефис.',
  alpha_num: () => 'Поле может содержать только буквы и цифры.',
  alpha_spaces: () => 'Поле может содержать только буквы и пробелы.',
  alpha: () => 'Поле может содержать только буквы.',
  between: (field, [min, max]) => `Поле должно быть между ${min} и ${max}.`,
  credit_card: () => 'Поле должно быть действительным номером карты',
  date_between: (field, [min, max]) => `Поле должно быть между ${min} и ${max}.`,
  date_format: (field, [format]) => `Поле должно быть в формате ${format}.`,
  email: () => 'Поле должно быть действительным электронным адресом.',
  ext: (field, [...args]) => `Поле должно быть действительным файлом. (${args})`,
  image: () => 'Поле должно быть изображением.',
  included: () => 'Поле должно быть допустимым значением.',
  ip: () => 'Поле должно быть действительным IP-адресом.',
  max: (field, [length]) => `Поле не может быть более ${length} символов.`,
  max_value: (field, [max]) => `Поле должно быть ${max} или менее.`,
  mimes: (field, [...args]) => `Поле должно иметь действительный тип файла. (${args})`,
  min: (field, [length]) => `Поле должно быть не менее ${length} символов.`,
  min_value: (field, [min]) => `Поле должно быть ${min} или больше.`,
  excluded: () => 'Поле должно быть допустимым значением.',
  numeric: () => 'Поле должно быть числом.',
  regex: () => 'Поле имеет ошибочный формат.',
  required: () => 'Поле обязательно для заполнения.',
  url: () => 'Поле имеет ошибочный формат URL.',
}

export default messages
